export function isExternalLink(url: string) {
  return /^[\w+.-]+:/.test(url);
}
